/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateUpdateAttachmentDto } from './CreateUpdateAttachmentDto';
import {
    CreateUpdateAttachmentDtoFromJSON,
    CreateUpdateAttachmentDtoFromJSONTyped,
    CreateUpdateAttachmentDtoToJSON,
} from './CreateUpdateAttachmentDto';

/**
 * 
 * @export
 * @interface CreateDeleteAttachmentsDto
 */
export interface CreateDeleteAttachmentsDto {
    /**
     * 
     * @type {Array<CreateUpdateAttachmentDto>}
     * @memberof CreateDeleteAttachmentsDto
     */
    attachmentsToAdd: Array<CreateUpdateAttachmentDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDeleteAttachmentsDto
     */
    attachmentsToDelete?: Array<string>;
}

/**
 * Check if a given object implements the CreateDeleteAttachmentsDto interface.
 */
export function instanceOfCreateDeleteAttachmentsDto(value: object): value is CreateDeleteAttachmentsDto {
    if (!('attachmentsToAdd' in value) || value['attachmentsToAdd'] === undefined) return false;
    return true;
}

export function CreateDeleteAttachmentsDtoFromJSON(json: any): CreateDeleteAttachmentsDto {
    return CreateDeleteAttachmentsDtoFromJSONTyped(json, false);
}

export function CreateDeleteAttachmentsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDeleteAttachmentsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'attachmentsToAdd': ((json['attachmentsToAdd'] as Array<any>).map(CreateUpdateAttachmentDtoFromJSON)),
        'attachmentsToDelete': json['attachmentsToDelete'] == null ? undefined : json['attachmentsToDelete'],
    };
}

export function CreateDeleteAttachmentsDtoToJSON(value?: CreateDeleteAttachmentsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attachmentsToAdd': ((value['attachmentsToAdd'] as Array<any>).map(CreateUpdateAttachmentDtoToJSON)),
        'attachmentsToDelete': value['attachmentsToDelete'],
    };
}

